<template>
  <v-app>
    <v-app-bar>
      <v-toolbar-title class="navbar"> <v-btn text :to="{ name: 'boards'}"><i class="far fa-sticky-note"></i> Ollert</v-btn></v-toolbar-title>
      
      <v-toolbar-items v-if="!user">
        <v-btn text :to="{ name: 'login'}">Login</v-btn>
        <v-btn text :to="{ name: 'signup'}">Sign Up</v-btn>
      </v-toolbar-items>
      <v-toolbar-items v-if="user">

         
          <v-row justify="space-around">
            <h3>{{user.user.displayName}}</h3>
            <v-avatar :size="40">
                <img
                  :src="user.user.imageUrl"
                  alt="John"
                >
            </v-avatar>
          </v-row>
           <v-btn text @click="logout">Log Out</v-btn>
          </v-toolbar-items>
        </v-app-bar>

    <v-content>
      <router-view />
    </v-content>
 
  </v-app>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
    name: 'App',
  data (){
    return {
      fixed: false,
    }
  },
  computed: {
    ...mapState('auth', {user: 'payload'})
  },
  methods: {
    ...mapActions('auth', {authLogout: 'logout'}),
    ...mapActions('auth', ['authenticate']),
    logout(){
      this.authLogout().then(()=> this.$router.push('/login'));
    }
  },
  mounted(){
    //  this.authenticate().then(() => {
    //             this.$router.push('/boards');
    //         }).catch(e => {
    //             console.error('Authentication error', e);
    //   });
  }
};
</script>

<style>
.v-content__wrap {
    background: linear-gradient(180deg,rgba(0,0,0,.24) 0,rgba(0,0,0,.24) 48px,transparent 80px,transparent);
}
.v-toolbar {
    flex: initial;
}
header.v-toolbar.v-app-bar {
    position: absolute;
}

.v-toolbar__content {
    justify-content: space-between;
}
.v-toolbar__items {
    align-items: center;
}
.v-toolbar__items .row.justify-space-around {
    align-items: center;
}
.v-toolbar__items h3 {
    padding-right: 5px;
}
header.v-sheet.v-toolbar.v-app-bar {
    height: 64px !important;
    background: rgba(47, 78, 130, 0.25);
    box-shadow: none;
}
.theme--light.v-app-bar.v-toolbar.v-sheet {
    background-color: #f5f5f557 !important;
}
.v-content__wrap {
    margin-top: 65px;
}
form.v-form {
    padding: 20px;
}
#board form.v-form {
    padding: 0;
}
.signUpWrap .v-content__wrap {
    margin: 0;
    
}
.navbar .v-toolbar__title {
    font-size: 1.25rem;
    border-radius: 3px;
    line-height: 1.5;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    background: rgba(0, 0, 0, 0.59);
}
.navbar .v-toolbar__title a.v-btn {
    color: #fff;
}
.v-application--wrap {
    background: linear-gradient(135deg, #0079bf, #5067c5);
    background-size: cover;
    background-repeat: no-repeat;
}
.v-toolbar__title i.far.fa-sticky-note {
       margin-right: 5px;
    font-size: 26px;
}
.v-toolbar__title span.v-btn__content {
   color: #fff;
    font-size: 21px;
    text-transform: initial;
    font-family: 'Pacifico';
}
html {
    font-family: 'Roboto', sans-serif;
}
#board .v-card .v-text-field__details {
    display: none;
}
.v-avatar img {
    object-fit: cover;
}
.flex.sm3 {
    flex-basis: 25%;
    flex-grow: 0;
    max-width: 25% !important;
}
@media (max-width: 500px){
  .layout.boards.row .flex.sm3.pa-2 {
    min-width: 100%;
 }
}
.layout.boards.row .flex.sm3.pa-2 {
    min-width: 300px;
}
</style>
